import { render } from "./D3CurationGraph.vue?vue&type=template&id=641563e1&scoped=true"
import script from "./D3CurationGraph.vue?vue&type=script&lang=js"
export * from "./D3CurationGraph.vue?vue&type=script&lang=js"

import "./D3CurationGraph.vue?vue&type=style&index=0&id=641563e1&scoped=true&lang=css"
import "./D3CurationGraph.vue?vue&type=style&index=1&id=641563e1&lang=scss"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641563e1"]])

export default __exports__